import { Col, Row } from "antd";
import { isEmpty, isUndefined } from "lodash";
import { MdArrowForward } from "react-icons/md";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import Select from "../Components/Select";

function View({ onNext, branches, selectedBranch, setSelectedBranch }) {
  return (
    <Layout>
      <Header
        title="Sélectionnez votre entreprise de rattachement pour<br />commencer"
        highlight="entreprise de rattachement"
        subtitle="Choix de l'entreprise"
      />

      <Row justify="center">
        <Col xs={24} md={18} lg={8}>
          <div className="grid--1">
            <Select
              variant="simple"
              label={"Entreprise"}
              defaultValue={selectedBranch}
              placeholder={"Sélectionnez ..."}
              options={branches.map(({ name }) => ({
                label: name,
                value: name,
              }))}
              onChange={setSelectedBranch}
              showSearch
            />
          </div>
        </Col>
      </Row>
      <ActionButtons
        onNext={onNext}
        disabled={isUndefined(selectedBranch) && !isEmpty(branches)}
        icon={<MdArrowForward size={24} />}
        buttonText="Allons-y !"
      />
    </Layout>
  );
}

export default View;
